import React, { useEffect, useState, useMemo } from 'react';
import { useReportsStore } from 'src/hooks/admin/reports';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { AgGridReact } from 'ag-grid-react';

import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import { __remove, __set } from 'src/store/axios_indicator';
import Helper from 'src/support/Helper';
import { useAdminAccountFilterStore } from 'src/hooks/admin/adminAccountFilter';
import useReduxState from 'src/hooks/useReduxState';
import Constants from 'src/support/Constants';
import Admin from '@system/config/admin';
import {
  ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY,
  ADMIN_USER_LAST_LOGIN_DATE_SEARCH_REQUEST_FIELD,
  getFormattedAdminUserLastLoginValue,
  getLastLoginFromDateValue,
  isAdminUserLastLoginDateSearchEnabled
} from 'src/support/AdminLastLoginDateSearch';
import { getForbiddenResponseMessage } from 'src/service/forbiddenResponseMessage';

const ReportList = () => {
  const [__check] = useAxiosIndicatorCheck();
  const [{ reportsList, totalRecords, filteredRecords, reportsListMessage }, { get_reports_list, get_export_report_list, email_report_list }, { set_reports_list, set_reports_list_message }] = useReportsStore();
  const [userListErrAlert, setUserListErrAlert] = useReduxState("", "setUserListErrAlert");
  const [errAlertType, setErrAlertType] = useReduxState("", "setErrAlertType");
  const [gridApi, setGridApi] = useState(null);
  const [rowData, setRowData] = useState([]);
  const gridRef = React.useRef();
  const [{ filter_list }, { }, { }] = useAdminAccountFilterStore();
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [agGridFiltered, setAgGridFiltered] = useState(0);
  const showLastLoginDateSearch = isAdminUserLastLoginDateSearchEnabled();

  useEffect(() => {
    async function fetchHere() {
      await fetchAPICall()
    }

    fetchHere();
  }, [filter_list]);

  const loadReportsDetail = (e) => {
    const data = e?.data ? e?.data : e.node.allLeafChildren[0]?.data;
    return <>
      <a href={Admin.getAdminAccountDetailURL() + '?accountNumber=' + data?.AccountNumber + '&salesOrg=' + data?.SalesOrg + '&speedboat=' + (data?.Speedboat == "Silica" ? 'S' : (data?.Speedboat == "Abacus" ? 'T' : 'B'))} className='' target="_blank"> {e?.value}</a>
    </>
  }

  const loadUserId = (e) => {
    return <>
      <a href={Admin.getAdminUserDetailURL() + '?uid=' + (e?.data?.UserID ? e?.data?.UserID : e.node.allLeafChildren[0]?.data?.UserID)} className='' target="_blank"> {e.value}</a>
    </>
  }
  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      enableRowGroup: true,
      enableValue: true,
      // lockPinned: true,
      resizable: true
    };
  }, []);

  useEffect(() => {
    let _reportsList = [];
    if (reportsList?.length > 0) {
      reportsList.map((_report, idx) => {
        let _data = {
          Email: _report.email,
          FirstName: _report.firstName,
          LastName: _report.lastName,
          LastLogin: getFormattedAdminUserLastLoginValue(_report),
          AccountNumber: _report.accountNumber,
          AccountName: _report.accountName,
          TelephoneNumber: _report.telephoneNumber,
          MobileNumber: _report.mobileNumber,
          Speedboat: _report.speedboat === 'T' ? 'Abacus' : (_report.speedboat === 'S' ? 'Silica' : 'EBV'),
          SalesOrg: _report.salesOrg,
          Role: _report.role,
          AccountStatus: _report.accountStatus ? 'Active' : 'Inactive',
          Description: _report.description,
          UserStatus: _report.userStatus ? "Active" : "Inactive",
          BillToCountry: _report.billtoCountry,
          Currency: _report.currency,
          CreatedOn: _report.createdOn ? Helper.getDatepickerFormatAdminConsole(_report.createdOn) : "",
          UpdatedOn: _report.updatedOn ? Helper.getDatepickerFormatAdminConsole(_report.updatedOn) : "",
          OrderBlock: _report.orderBlock ? 'Yes' : 'No',
          CreditRisk: _report.creditRisk ? 'Yes' : 'No',
          Payment: _report.payment,
          SdiNumber: _report.sdiNumber,
          PecEmail: _report.pecEmail,
          UserID: _report.userID,
        }
        _reportsList.push(_data);
      })
    }
    setRowData(_reportsList)
  }, [reportsList]);
  const [columnDefs, setColumnDefs] = useState([

    {
      field: 'Email',
      headerName: 'EMAIL',
      headerTooltip: 'EMAIL',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130,
      lockPosition: 'left',
      pinned: 'left',
      suppressMovable: true,
      cellRenderer: loadUserId,
    },
    {
      field: 'FirstName',
      headerName: 'FIRST NAME',
      headerTooltip: 'FIRST NAME',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 150,
      lockPosition: 'left',
      pinned: 'left',
      suppressMovable: true
    },
    {
      field: 'LastName',
      headerName: 'LAST NAME',
      headerTooltip: 'LAST NAME',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 150,
      lockPosition: 'left',
      pinned: 'left',
      suppressMovable: true,
    },
    {
      field: 'LastLogin',
      headerName: 'LAST LOGIN',
      headerTooltip: 'LAST LOGIN',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      minWidth: 150,
      lockPosition: 'left',
      pinned: 'left',
      suppressMovable: true,
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        comparator: Helper.calendarAgGridComparator,
      }
    },
    {
      field: 'AccountNumber',
      headerName: 'ACCOUNT NUMBER',
      headerTooltip: 'ACCOUNT NUMBER',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 150,
      lockPosition: 'left',
      pinned: 'left',
      cellRenderer: loadReportsDetail,
    },
    {
      field: 'AccountName',
      headerName: 'ACCOUNT NAME',
      headerTooltip: 'ACCOUNT NAME',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 150
    },
    {
      field: 'TelephoneNumber',
      headerName: 'TELEPHONE NUMBER',
      headerTooltip: 'TELPHONE NUMBER',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'MobileNumber',
      headerName: 'MOBILE NUMBER',
      headerTooltip: 'MOBILE NUMBER',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'Speedboat',
      headerName: 'SPEEDBOAT',
      headerTooltip: 'SPEEDBOAT',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'SalesOrg',
      headerName: 'SALES ORG',
      headerTooltip: 'SALES ORG',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'Role',
      headerName: 'ROLE',
      headerTooltip: 'ROLE',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'AccountStatus',
      headerName: 'ACCOUNT STATUS',
      headerTooltip: 'ACCOUNT STATUS',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'Description',
      headerName: 'DESCRIPTION',
      headerTooltip: 'DESCRIPTION',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'UserStatus',
      headerName: 'USER STATUS',
      headerTooltip: 'USER STATUS',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'BillToCountry',
      headerName: 'BILL TO COUNTRY',
      headerTooltip: 'BILL TO COUNTRY',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'Currency',
      headerName: 'CURRENCY',
      headerTooltip: 'CURRENCY',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'CreatedOn',
      headerName: 'CREATED ON',
      headerTooltip: 'CREATED ON',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      minWidth: 130,
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        comparator: Helper.calendarAgGridComparator,
      }
    },
    {
      field: 'UpdatedOn',
      headerName: 'UPDATED ON',
      headerTooltip: 'UPDATED ON',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      minWidth: 130,
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        comparator: Helper.calendarAgGridComparator,
      }
    },
    {
      field: 'OrderBlock',
      headerName: 'ORDER BLOCK',
      headerTooltip: 'ORDER BLOCK',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'CreditRisk',
      headerName: 'CREDIT RISK',
      headerTooltip: 'CREDIT RISK',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'Payment',
      headerName: 'PAYMENT',
      headerTooltip: 'PAYMENT',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'SdiNumber',
      headerName: 'SDI NUMBER',
      headerTooltip: 'SDI NUMBER',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
    {
      field: 'PecEmail',
      headerName: 'PEC EMAIL',
      headerTooltip: 'PEC EMAIL',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 130
    },
  ].filter(column => showLastLoginDateSearch || column.field !== 'LastLogin'));

  const fetchAPICall = async () => {
    __set('USER_REPORT_API_CALL')
    if (Object.entries(filter_list).length > 0) {
      const params = getReportSearchParams()
      const filterListObject = filter_list?.speedboat?.searchKeyword

      if (!filterListObject) {
        setUserListErrAlert(
          "Please select Speedboat",
          "danger",
          "searchAccount"
        );
        setErrAlertType("danger");
        __remove('USER_REPORT_API_CALL')
        return;
      }
      await get_reports_list(params)
    } else {
      set_reports_list()
    }
    __remove('USER_REPORT_API_CALL')
  };
  const getReportSearchParams = () => {
    const params = {
      accountName: filter_list?.accountName?.searchKeyword ? filter_list?.accountName?.searchKeyword : null,
      accountNumber: filter_list?.accountNumber?.searchKeyword ? filter_list?.accountNumber?.searchKeyword : null,
      speedBoat: filter_list?.speedboat?.searchKeyword ? (filter_list?.speedboat?.searchKeyword === "Silica" ? 'S' : filter_list?.speedboat?.searchKeyword === "Abacus" ? 'T' : 'B') : null,
      salesOrg: filter_list?.salesOrg?.searchKeywordArr ? filter_list?.salesOrg?.searchKeywordArr.map(item => item.value) : [],
      accountStatus: filter_list?.accountActive?.searchKeyword ? (filter_list?.accountActive?.searchKeyword === "Yes") : null,
      country: filter_list?.country?.searchKeywordArr ? filter_list?.country?.searchKeywordArr.map(item => item.value) : [],
      createdDate: filter_list?.createdDate?.searchKeyword ? Helper.convertToYYMMDD(filter_list?.createdDate?.searchKeyword) : null,
      firstName: filter_list?.userFirstName?.searchKeyword ? filter_list?.userFirstName?.searchKeyword : null,
      lastName: filter_list?.userLastName?.searchKeyword ? filter_list?.userLastName?.searchKeyword : null,
      userStatus: filter_list?.userActive?.searchKeyword ? (filter_list?.userActive?.searchKeyword === "Yes") : null,
      role: filter_list?.role?.searchKeyword ? filter_list?.role?.searchKeyword : null,
      email: filter_list?.email?.searchKeyword ? filter_list?.email?.searchKeyword : null,
    };
    const lastLoginFromDate = showLastLoginDateSearch
      ? getLastLoginFromDateValue(filter_list?.[ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY]?.searchKeyword)
      : null;

    if (lastLoginFromDate) {
      params[ADMIN_USER_LAST_LOGIN_DATE_SEARCH_REQUEST_FIELD] = lastLoginFromDate;
    }

    return params;
  }
  const gridUpdateCallback = (event) => {
    setAgGridFiltered(event.api.getDisplayedRowCount());
  }

  const onGridReady = (params) => {
    setAgGridFiltered(params.api.getDisplayedRowCount());
    params.api.addEventListener('filterChanged', gridUpdateCallback)
    params.api.addEventListener('filterModified', gridUpdateCallback)
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  const exportGrid = async () => {
    $('#emailFilter').removeClass('open');
    __set('COMMON_API_CALL');
    try {
      set_reports_list_message('');
      if (agGridFiltered <= 2000) {
        // Fetch All Columns
        const allColumnState = gridColumnApi.getColumnState();
        // Filter Out Visible Columns
        const customColumns = allColumnState?.filter((column) => column.hide !== true && column.colId != '0')
          .map((column) => column.colId);

        let params = { fileName: `report_list.xlsx`, sheetName: "Report", columnKeys: customColumns };

        gridRef.current?.api.exportDataAsExcel(params);
        setUserListErrAlert(Constants.downloadMsg, 'success', 'addUser');
        setErrAlertType('success');
      } else {
        const params = getReportSearchParams()
        const res = await email_report_list(params);
        setUserListErrAlert("File will be sent as an email attachment due to large number of records", 'success', 'addUser');
        setErrAlertType('success');
      }
    } catch (error) {
      set_reports_list_message(getForbiddenResponseMessage(error) || 'Something went wrong');
    } finally {
      __remove('COMMON_API_CALL');
    }
  }
  const onExportAll = async () => {
    $('#emailFilter').removeClass('open');
    __set('COMMON_API_CALL');
    try {
      set_reports_list_message('');
      if (totalRecords > 0 && totalRecords < 2000) {
        const customColumns = gridColumnApi?.getColumnState?.()
          ?.filter((column) => column.hide !== true && column.colId != '0')
          ?.map((column) => column.colId) || [];

        if (gridRef.current?.api && customColumns.length > 0) {
          let params = {
            fileName: `report_list.xlsx`,
            sheetName: "Report",
            columnKeys: customColumns,
            exportedRows: 'all'
          };
          gridRef.current.api.exportDataAsExcel(params);
        } else {
          const data = await get_export_report_list({});
          Helper.downloadFileFromRes(data, 'report_list.xlsx');
        }
        setUserListErrAlert(Constants.downloadMsg, 'success', 'addUser');
        setErrAlertType('success');
      } else {
        const res = await email_report_list();
        setUserListErrAlert("File will be sent as an email attachment due to large number of records", 'success', 'addUser');
        setErrAlertType('success');
      }
    } catch (error) {
      set_reports_list_message(getForbiddenResponseMessage(error) || 'Something went wrong');
    } finally {
      __remove('COMMON_API_CALL');
    }
  }
  return (
    <>
      {rowData.length > 0 &&
        <div className='w-100 d-flex align-items-center justify-content-between status-bar p-2'>
          <div className="d-flex justify-content-start">
            Filtered Line Count: <b>{agGridFiltered}</b>
          </div>
          <div className="d-flex justify-content-end">
            Total Records: <b>{totalRecords}</b>
          </div>
        </div>}
      <div className='bg-black p-2'>
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center'></div>
          <div className='d-flex align-items-center'>
            <span id="emailFilter" className="dropdown">
              <a href={void (0)} data-toggle="dropdown" aria-expanded="false" className='text-white'>
                <i className="fa fa-download me-1" aria-hidden="true"></i> Export List
              </a>
              <ul className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton1">
                <li><a href={void (0)} onClick={onExportAll}>Export All</a></li>
                {rowData.length > 0 && <li><a href={void (0)} onClick={exportGrid}>Export Filtered</a></li>}
              </ul>
            </span>
          </div>
        </div>
      </div>

      {__check(['USER_REPORT_API_CALL', 'COMMON_API_CALL']).render}
      {!__check(['USER_REPORT_API_CALL', 'COMMON_API_CALL']).status &&
        <>
          {rowData?.length > 0 && reportsListMessage &&
            <div className='container mt-5'>
              <NoResultContent message={reportsListMessage} type='danger' isDisplay={false} />
            </div>
          }
          {rowData?.length > 0 ?
            <div className="ag-theme-alpine ag-grd-hg mb-5">
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                suppressRowClickSelection={true}
                onGridReady={onGridReady}
                autoGroupColumnDef={{
                  headerName: 'Group',
                  minWidth: 220,
                }}
              >
              </AgGridReact>
            </div> :
            <>
              {(Object.entries(filter_list).length > 0 || reportsListMessage) ?
                <div className='container mt-5'>
                  <NoResultContent message={reportsListMessage || `Sorry! We can't find any results based on your selection.`}
                    type={reportsListMessage ? 'danger' : 'info'}
                    isDisplay={false} />
                </div>
                : <div className='d-block pt-5 pb-5 mt-5 mb-5 minh150'></div>
              }
            </>
          }
        </>
      }
    </>
  );
}

export default ReportList;
